import { format as dateFormat, isDate } from 'date-fns'
import type { i18n as I18NType, InitOptions } from 'i18next'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { defaultOptions } from './i18n'

export const configureI18n = ({
  fallbackLng,
  supportedLngs,
  detection,
  resources = {},
}: Partial<InitOptions>): I18NType => {
  void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng,
      // have a common namespace used around the full app
      ns: ['translations'],
      supportedLngs,
      load: 'all',
      lowerCaseLng: true,
      defaultNS: 'translations',
      debug: false,
      interpolation: {
        escapeValue: false,
      },
      detection,
      resources,
      returnEmptyString: false,
    })

  i18n.services?.formatter?.add('date', (value, _lng, options) => {
    if (isDate(value)) {
      return dateFormat(
        value,
        options?.formatStyle ?? 'dd/MM/yyyy',
        defaultOptions(),
      )
    }
    return String(value)
  })

  return i18n
}
